module.exports = __webpack_public_path__ + "cfb276008ef60bb1035b81763886decf.png";